import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ColorPickerModule as CPModule } from 'ngx-color-picker';
import { ColorPickerComponent } from './color-picker.component';

@NgModule({
    declarations: [
        ColorPickerComponent
    ],
    imports: [
        CPModule,
        CommonModule,
    ],
    exports: [
        ColorPickerComponent
    ]
})
export class ColorPickerModule { }